// Counts signed-in, foreground APK use without collecting device identifiers.
// This is adoption analytics, not proof that a user installed/uninstalled an app.
export function startAppUsageTracking() {
    if (!/(?:^|\s)(?:NamiGamesAndroid|RickEliteSpinsAndroid|HittingSlotsAndroid|LuckyVaultAndroid)\/\d+(?:\.\d+){1,3}(?=\s|$)/.test(navigator.userAgent)) return () => {};
    let stopped = false;
    let busy = false;
    let lastToken = null;
    let nextAt = 0;
    let controller = null;
    const tick = async () => {
        if (stopped || busy || document.visibilityState !== "visible" || window.location.pathname.startsWith("/admin")) return;
        let token;
        try { token = localStorage.getItem("clubsClientToken"); } catch { return; }
        if (!token) { lastToken = null; nextAt = 0; return; }
        if (token !== lastToken) { nextAt = 0; lastToken = token; }
        if (Date.now() < nextAt) return;
        busy = true;
        controller = new AbortController();
        const timeout = window.setTimeout(() => controller?.abort(), 5000);
        nextAt = Date.now() + 60000;
        try {
            const res = await fetch("/api/client/app-usage", {
                method: "POST", headers: { Authorization: `Bearer ${token}` },
                credentials: "omit", cache: "no-store", signal: controller.signal,
            });
            if (res.ok && !stopped) nextAt = Date.now() + 5 * 60000;
        } catch { /* best effort; never interrupts launch or payments */ }
        finally { clearTimeout(timeout); busy = false; }
    };
    tick();
    const interval = window.setInterval(tick, 30000);
    document.addEventListener("visibilitychange", tick);
    window.addEventListener("focus", tick);
    return () => {
        stopped = true;
        controller?.abort();
        clearInterval(interval);
        document.removeEventListener("visibilitychange", tick);
        window.removeEventListener("focus", tick);
    };
}
